/**
 * MarkdownContent — renders a user-opened .md file inside the file viewer.
 *
 * Uses the shared <CellCogMarkdown>. Continues to:
 *   - Strip YAML frontmatter (remark would otherwise treat the whole block
 *     as text before the final --- marker).
 *   - Default fenced code blocks to Rich mode (so a ```html or ```markdown
 *     block inside a doc renders with preview, not source).
 *
 * Does NOT resolve SHOW_FILE / GENERATE_FILE tags — they are SDK protocol
 * syntax and don't belong in a rendered markdown file view.
 */
import React from 'react';
import CellCogMarkdown from '../../../Common/CellCogMarkdown';
import RichCodeBlock from '../../../Common/RichCodeBlock';

/**
 * Strip YAML frontmatter from markdown content.
 * remark-parse does not consume --- delimited frontmatter blocks
 * specially; without this strip, the frontmatter becomes a horizontal-rule
 * + body split where the body swallows everything between the two rules.
 */
export const stripFrontmatter = (text) => {
  if (typeof text !== 'string') return text;
  const match = text.match(/^---\r?\n[\s\S]*?\r?\n---\r?\n/);
  return match ? text.slice(match[0].length) : text;
};

const MarkdownContent = ({ content, isDarkMode }) => {
  return (
    <div className="file-viewer-markdown-scroll">
      <div className="file-viewer-markdown-document">
        <CellCogMarkdown
          content={stripFrontmatter(content || '')}
          isDarkMode={isDarkMode}
          enableCellCogTags="none"
          codeBlockComponent={RichCodeBlock}
          richCodeDefaultMode="rich"
        />
      </div>
    </div>
  );
};

export default MarkdownContent;
